module.exports = __webpack_public_path__ + "img/7img_page-0001.03f9f7d6.jpg";